export default "__VITE_ASSET__CrpJKNd8__"